import React from 'react';
import { Svg, Path } from "react-native-svg-web";


export const EmailIcon = ({
  className,
  color = '#333333',
  size = '24px',
  style }) => /*#__PURE__*/

React.createElement(Svg, {

  className: className,
  style: style,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7ZM20 8.28847V15.5858L15.9739 11.5597L20 8.28847ZM18.4142 7L12 12.2115L5.58581 7L18.4142 7ZM4 8.28847V15.5858L8.02611 11.5597L4 8.28847ZM5.41421 17H18.5858L14.4134 12.8276L12 14.7885L9.58662 12.8276L5.41421 17Z",
  fill: color }));